<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.LIST_OF_SHIPPEND_PRODUCTS_IN_CT_MARKING' | translate }}</div>
                <div class="tools">

                    <button type="button" class="btn btn-light btn-sm" routerLink="/export">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>

                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-file-earmark-text"></i>{{ 'CREATE_ENTRY' | translate }} 
                    </button>

                    <div class="item-list">

                        <div class="dropleft">
                            <button class="btn btn-primary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" *ngIf="checkedCheckBox()">
                              {{ 'CHOOSE_AN_ACTION' | translate }}
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <div class="dropdown-item" *ngFor="let item of actionsList" (click)="getAction(item.id, item.action)" [ngClass]="{'hide': !checkState(item.action)}"> 
                                  <div>{{item.name}}</div>
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
               
               

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_all"
                                        id="select_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name"> {{ 'PRODUCT.PRODUCT_NAME' | translate }}</th>
                            <th scope="col" class="gtin"> GTIN</th>
                            <th scope="col" class="create_date"> {{ 'FILES.DATE_OF_CREATE' | translate }}</th>
                            <th scope="col" class="sending_date"> {{ 'PRICE.DATE_THE_INVITATION' | translate }}</th>
                            <th scope="col" class="sending_date"> {{ 'STATUS' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="listData && listData.length > 0">
                        <tr *ngFor="let list of listData; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_{{ i }}"
                                        id="select_{{ i }}" [checked]="list.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                        <label class="custom-control-label" for="select_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{ list.product_name }}</td>
                            <td class="gtin">{{ list.gtin }}</td>
                            <td class="create_date">{{ list.create_date }}</td>
                            <td class="sending_date">{{ list.sending_date }}</td>
                            <td class="sending_date">{{ list.state.name }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light"
                                    (click)="getProfile(list.id)" placement="top"
                                    ngbTooltip="{{ 'WATCH' | translate }}">
                                    <i class="bi bi-eye"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onEdit(list.product_id)" placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onDelete([list.id])" placement="top"
                                    ngbTooltip="{{ 'DELETE' | translate }}" [disabled]="!permissionAccess.check('MARKING_DELETE_IMPORT_PRODUCTS', list.state.id)">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!listData || listData.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="5">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="5">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>